import { useSyncExternalStore } from 'react';

// Pleasant Color Theme Engine: 'pleasant-light' | 'pleasant-midnight' | 'pleasant-ocean'
const THEME_KEY = 'election_police_theme';
export const DEFAULT_THEME = 'pleasant-light';

const listeners = new Set();

export function getSavedTheme() {
  try {
    return localStorage.getItem(THEME_KEY) || DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
}

let current = getSavedTheme();

function paint(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  if (document.body) document.body.setAttribute('data-theme', theme);
}

export function setTheme(theme = DEFAULT_THEME) {
  current = theme;
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
    /* storage unavailable */
  }
  paint(theme);
  listeners.forEach((l) => l());
}

export function initTheme() {
  paint(current);
  // cross-tab sync
  window.addEventListener('storage', (e) => {
    if (e.key === THEME_KEY && e.newValue && e.newValue !== current) {
      current = e.newValue;
      paint(current);
      listeners.forEach((l) => l());
    }
  });
  // legacy inline handlers / controllers
  window.setAppTheme = setTheme;
  window.getAppTheme = getSavedTheme;
}

const subscribe = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

export function useTheme() {
  const theme = useSyncExternalStore(subscribe, () => current);
  return [theme, setTheme];
}
